"use client";
import Link from "next/link";
import { ArrowRight, BarChart3 } from "lucide-react";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { successMetrics as data } from "@/lib/data/mission";

const accents = ["var(--color-amber)", "var(--color-cyan)", "var(--color-emerald)"];

export function SuccessMetrics() {
  return (
    <Section id="metrics" className="relative">
      <Container>
        <Reveal>
          <div className="max-w-3xl">
            <span className="eyebrow-tiny text-[var(--color-amber)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
            <p className="mt-5 text-body text-[rgb(var(--fg-muted))] leading-relaxed">{data.intro}</p>
          </div>
        </Reveal>
        <div className="mt-12 grid lg:grid-cols-3 gap-5">
          {data.categories.map((c, i) => {
            const accent = accents[i % accents.length]!;
            return (
              <Reveal key={c.title} delay={i * 100}>
                <div className="glass rounded-2xl p-6 h-full" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 18%, transparent)` }}>
                  <div className="flex items-center gap-3">
                    <span className="grid place-items-center h-11 w-11 rounded-xl" style={{ background: `color-mix(in oklch, ${accent} 18%, transparent)`, boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 35%, transparent)` }}>
                      <BarChart3 className="h-5 w-5" style={{ color: accent }} />
                    </span>
                    <h3 className="text-lg">{c.title}</h3>
                  </div>
                  <ul className="mt-4 space-y-2">
                    {c.stats.map((s, j) => (
                      <li key={j} className="text-sm text-[rgb(var(--fg-muted))] leading-relaxed">
                        <span style={{ color: accent }}>•</span> {s}
                      </li>
                    ))}
                  </ul>
                </div>
              </Reveal>
            );
          })}
        </div>
        <Reveal delay={500}>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            {data.cta.map((c, i) => (
              <Link key={c.label} href={c.href} className={i === 0 ? "btn-primary-gradient h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm" : "btn-glass h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm"}>
                {c.label} <ArrowRight className="h-3.5 w-3.5" />
              </Link>
            ))}
          </div>
        </Reveal>
      </Container>
    </Section>
  );
}
